import { createApp } from 'vue'
import { createPinia } from 'pinia'
import dayjs from 'dayjs';
import dayjsLocales from '../../services/dayjs-locales.service';
import localeData from 'dayjs/plugin/localeData';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import weekOfYear from 'dayjs/plugin/weekOfYear';
import Vue3TouchEvents, {
  type Vue3TouchEventsOptions,
} from "vue3-touch-events";

// Select the App you want to run on main, each individual are on /appName/App.vue
import App from './App.vue'

// import library styles
import '../../styles/tailwind.css'
import '@vueform/slider/themes/default.css'

// import custom styles
import './style.css'
import '../../styles/property_page.scss'
import {cleanUpPropertyId, isWellFormedPropertyId} from "@/services/formatting.service.ts";
import {CampayaCoreApiClient} from "@/services/campayacore-api.service.ts";
import {preLoadTextIds} from "@/services/translation.service.ts";

const propertyPageSsrTextIds = [
  14244, 14245, 14246, 14247, 14248,
  14302, 14304, 14303, 8374, 13889,
  13860, 13900, 14249, 14344, 14340,
  14341, 14342, 14343, 14159
]

let locale = document.documentElement.lang;

async function loadLocale() {
  if (!dayjsLocales[locale]) {
    locale = 'default';
  }

  const localeData = await dayjsLocales[locale]().then(() => dayjs.locale(locale));
  dayjs.locale(localeData);
}

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);


async function initApp() {
  await loadLocale();
  dayjs.extend(localeData);
  dayjs.extend(isoWeek);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(customParseFormat);
  dayjs.extend(isBetween);
  dayjs.extend(weekOfYear);
  dayjs.localeData();

  const apiClient = new CampayaCoreApiClient();
  const propertyId = window.location.pathname.split('/')[1];
  const cleanedPropertyId = cleanUpPropertyId(propertyId);

  // Prevents spurious API calls when the SPA initialises on an unexpected URL
  // (e.g. "/search" due to iOS Safari back/forward cache behaviour).
  const isValidPropertyId = isWellFormedPropertyId(cleanedPropertyId);

  const [propertyModel]= await Promise.all([
    isValidPropertyId ? apiClient.propertyPage(cleanedPropertyId) : Promise.resolve(undefined),
    preLoadTextIds(propertyPageSsrTextIds)
  ]);
  const app = createApp(App, {
    productModalData: propertyModel ?? {}
  });
  app.use<Vue3TouchEventsOptions>(Vue3TouchEvents, {})

  app.config.globalProperties.$dayjs = dayjs;

  app.use(pinia)
  app.mount("#app")
}

initApp();
